// Whether the panel is open on screen right now, for layouts that change with
// it (the Analytics Overview footer). The shell publishes; others read. This is
// the live state, not the preference kept by writeDopamineAssistantOpenState.
const DOPAMINE_ASSISTANT_OPEN_EVENT = 'dopamine-assistant:open'

let isDopamineAssistantOpen = false

export const publishDopamineAssistantOpen = (isOpen: boolean): void => {
  if (isDopamineAssistantOpen === isOpen) return

  isDopamineAssistantOpen = isOpen
  window.dispatchEvent(new Event(DOPAMINE_ASSISTANT_OPEN_EVENT))
}

export const getDopamineAssistantOpen = (): boolean => isDopamineAssistantOpen

export const subscribeToDopamineAssistantOpen = (
  listener: () => void,
): (() => void) => {
  window.addEventListener(DOPAMINE_ASSISTANT_OPEN_EVENT, listener)
  return () =>
    window.removeEventListener(DOPAMINE_ASSISTANT_OPEN_EVENT, listener)
}
